import axios from 'axios';
import { apiExpertCourses } from '../constants/api';
import { getToken } from '../services/AuthService';

// eslint-disable-next-line import/prefer-default-export
export const apiGetExpertCourses = async () => {
  const token: string = await getToken();
  const data = await axios.get(
    `${process.env.REACT_APP_API_ROOT}${apiExpertCourses}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
};
